import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {AuthService} from './auth.service';
import {APP_CONFIG} from "../app.config";

/**
 * Guard for application entry point (redirect from backend).
 * Moves JSON web token from cookie (sent by backend) to local storage.
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const appConfig = inject(APP_CONFIG);

  /**
   * Returns true if user is authenticated.
   *
   * Redirect to Partner.NET in case of invalid / expired login.
   */
  if (authService.authenticate()) {
    return true;
  }
  window.open(appConfig.loginUrl, '_self');
  return false;
};
